// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dg-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.dg-title { margin: 0 0 6px 0; }
.dg-subtitle { margin: 0 0 16px 0; opacity: 0.8; }

.dg-error {
  padding: 12px;
  border: 1px solid rgba(0,0,0,0.14);
  border-radius: 10px;
  background: rgba(255,0,0,0.06);
}

.dg-section {
  margin-top: 16px;
  border: 1px solid rgba(0,0,0,0.10);
  border-radius: 12px;
  padding: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0,0,0,0.05);
}

.dg-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.dg-badge {
  font-size: 12px;
  padding: 2px 8px;
  border: 1px solid rgba(0,0,0,0.18);
  border-radius: 999px;
  opacity: 0.8;
}

.dg-section-desc { margin-top: 6px; opacity: 0.8; }

.dg-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, minmax(240px, 1fr));
  gap: 14px;
}

@media (max-width: 980px) { .dg-grid { grid-template-columns: repeat(2, minmax(240px, 1fr)); } }
@media (max-width: 620px) { .dg-grid { grid-template-columns: 1fr; } }

.dg-card {
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 12px;
  padding: 14px;
  background: #fff;
}

.dg-card-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.dg-card-title { font-weight: 700; }
.dg-card-sub { font-size: 12px; opacity: 0.7; }

.dg-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px dashed rgba(0,0,0,0.12);
  padding-top: 8px;
  margin-top: 8px;
}

.dg-label { opacity: 0.75; }
.dg-value-strong { font-weight: 700; }
.dg-value-soft { font-weight: normal; opacity: 0.75; }

.dg-btn {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 10px;
}

.dg-digital-state {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 6px;
}

.dg-muted { opacity: 0.7; padding: 10px 0; }

/* Gauge */
.dg-gauge { display: flex; justify-content: center; margin: 6px 0 4px 0; }
.dg-arc { fill: none; stroke: rgba(0,0,0,0.18); stroke-width: 12; stroke-linecap: round; }
.dg-tick { stroke: rgba(0,0,0,0.35); stroke-width: 2; }
.dg-needle { stroke: rgba(0,0,0,0.85); stroke-width: 3; stroke-linecap: round; }
.dg-cap { fill: rgba(0,0,0,0.85); }
.dg-value { fill: rgba(0,0,0,0.85); font-weight: 700; font-size: 14px; }

/* IO input row */
.dg-io {
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 10px;
  margin-top: 10px;
}

.dg-input {
  width: 100%;
  border: 1px solid rgba(0,0,0,0.18);
  border-radius: 10px;
  padding: 10px 12px;
  outline: none;
}

.dg-local-error {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255,0,0,0.22);
  background: rgba(255,0,0,0.06);
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/pages/DynamicPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,YAAY,iBAAiB,EAAE;AAC/B,eAAe,kBAAkB,EAAE,YAAY,EAAE;;AAEjD;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,YAAY;AACd;;AAEA,mBAAmB,eAAe,EAAE,YAAY,EAAE;;AAElD;EACE,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA,4BAA4B,WAAW,oDAAoD,EAAE,EAAE;AAC/F,4BAA4B,WAAW,0BAA0B,EAAE,EAAE;;AAErE;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB,gBAAgB,EAAE;AACnC,eAAe,eAAe,EAAE,YAAY,EAAE;;AAE9C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY,aAAa,EAAE;AAC3B,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,mBAAmB,EAAE,aAAa,EAAE;;AAErD;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,YAAY,YAAY,EAAE,eAAe,EAAE;;AAE3C,UAAU;AACV,YAAY,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzE,UAAU,UAAU,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACzF,WAAW,wBAAwB,EAAE,eAAe,EAAE;AACtD,aAAa,wBAAwB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC/E,UAAU,sBAAsB,EAAE;AAClC,YAAY,sBAAsB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEvE,iBAAiB;AACjB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".dg-container {\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dg-title { margin: 0 0 6px 0; }\n.dg-subtitle { margin: 0 0 16px 0; opacity: 0.8; }\n\n.dg-error {\n  padding: 12px;\n  border: 1px solid rgba(0,0,0,0.14);\n  border-radius: 10px;\n  background: rgba(255,0,0,0.06);\n}\n\n.dg-section {\n  margin-top: 16px;\n  border: 1px solid rgba(0,0,0,0.10);\n  border-radius: 12px;\n  padding: 14px;\n  background: #fff;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.05);\n}\n\n.dg-section-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.dg-badge {\n  font-size: 12px;\n  padding: 2px 8px;\n  border: 1px solid rgba(0,0,0,0.18);\n  border-radius: 999px;\n  opacity: 0.8;\n}\n\n.dg-section-desc { margin-top: 6px; opacity: 0.8; }\n\n.dg-grid {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n@media (max-width: 980px) { .dg-grid { grid-template-columns: repeat(2, minmax(240px, 1fr)); } }\n@media (max-width: 620px) { .dg-grid { grid-template-columns: 1fr; } }\n\n.dg-card {\n  border: 1px solid rgba(0,0,0,0.12);\n  border-radius: 12px;\n  padding: 14px;\n  background: #fff;\n}\n\n.dg-card-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.dg-card-title { font-weight: 700; }\n.dg-card-sub { font-size: 12px; opacity: 0.7; }\n\n.dg-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  border-top: 1px dashed rgba(0,0,0,0.12);\n  padding-top: 8px;\n  margin-top: 8px;\n}\n\n.dg-label { opacity: 0.75; }\n.dg-value-strong { font-weight: 700; }\n.dg-value-soft { font-weight: normal; opacity: 0.75; }\n\n.dg-btn {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.dg-digital-state {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.dg-muted { opacity: 0.7; padding: 10px 0; }\n\n/* Gauge */\n.dg-gauge { display: flex; justify-content: center; margin: 6px 0 4px 0; }\n.dg-arc { fill: none; stroke: rgba(0,0,0,0.18); stroke-width: 12; stroke-linecap: round; }\n.dg-tick { stroke: rgba(0,0,0,0.35); stroke-width: 2; }\n.dg-needle { stroke: rgba(0,0,0,0.85); stroke-width: 3; stroke-linecap: round; }\n.dg-cap { fill: rgba(0,0,0,0.85); }\n.dg-value { fill: rgba(0,0,0,0.85); font-weight: 700; font-size: 14px; }\n\n/* IO input row */\n.dg-io {\n  display: grid;\n  grid-template-columns: 1fr 120px;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.dg-input {\n  width: 100%;\n  border: 1px solid rgba(0,0,0,0.18);\n  border-radius: 10px;\n  padding: 10px 12px;\n  outline: none;\n}\n\n.dg-local-error {\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(255,0,0,0.22);\n  background: rgba(255,0,0,0.06);\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
